import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from '../../components/auth/LoginModal';
import RegisterModal from '../../components/auth/RegisterModal';
import './AuthPage.css';

const LoginPage = () => {
  const { isAuthenticated, user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const message = location.state?.message;
  const messageType = location.state?.type || 'info';
  
  // If user is already authenticated, redirect to appropriate dashboard
  useEffect(() => {
    if (isAuthenticated) {
      if (user?.user_type === 'content_creator' || user?.user_type === 'super_admin') {
        navigate('/dashboard/content-creator');
      } else if (user?.user_type === 'general_user') {
        navigate('/dashboard/general-user');
      }
    }
  }, [isAuthenticated, user, navigate]);
  
  // Handle switching to register modal
  const handleSwitchToRegister = () => {
    setShowRegisterModal(true);
  };
  
  // Handle closing register modal
  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
  };

    // else if (userData?.user_type === 'super_admin') {
    //     navigate('/dashboard/super-admin');
    // }
  // Handle navigation after successful login (used by LoginModal)
  const handleLoginSuccess = (userData) => {
    // Check if redirected here with a "from" location (e.g., from /credits)
    const from = location.state?.from;
    if (from) {
      navigate(from, { replace: true });
    }else if (userData?.user_type === 'content_creator' || userData?.user_type === 'super_admin') {
      navigate('/dashboard/content-creator');
    }else {
      navigate('/dashboard/general-user');
    }
  };
  
  return (
    <div className="auth-page-container">
      {message && (
        <div className={`alert alert-${messageType}`}>
          {message}
        </div>
      )}
      
      {/* Use the existing LoginModal with isOpen always true for the page version */}
      <LoginModal 
        isOpen={true} 
        onClose={() => navigate('/')} 
        onSwitchToRegister={handleSwitchToRegister}
        onLoginSuccess={handleLoginSuccess}
        isStandalonePage={true} // Prop to indicate this is used as a page, not a modal
        login={login}
      />
      
      {/* Register Modal that appears when user clicks "Register" from the login form */}
      <RegisterModal 
        isOpen={showRegisterModal} 
        onClose={handleCloseRegisterModal} 
        onSwitchToLogin={() => setShowRegisterModal(false)}
      />
    </div>
  );
};

export default LoginPage;